import './FrameCard.scss'
import { useSelector } from 'react-redux'

const FrameCard = (props) => {

    const selectedStore = useSelector(state => state.popupData.selectedStore);

    return (
        <div className='container-fluid frame-card-container'>
            <div className='row frame-card'>
                <div className={'col-6' + (selectedStore && selectedStore.x_storeFound === "false" ? ' opacity-4' : '')}>
                    <img alt='frame' src={props.config.data.frame.imageUrl} className='glasses-frame'>
                    </img>
                </div>
                <div className={'frame-information align-center' + (selectedStore && selectedStore.x_storeFound === "false" ? ' opacity-4' : '')}>
                    <span className="brand">{props.config.data.frame.brand}</span>
                    <span className="model">{props.config.data.frame.name}</span>
                    <span className="price">${props.config.data.frame.listPrice}</span>
                </div>
                <div className="line-spacer"></div>
            </div>
        </div>
    )
}

export default FrameCard
